import { Component, OnInit } from "@angular/core";
import { DownloadService } from "../base/services/download.service";
import { FileLoaderService } from "../services/file-loader.service";

@Component({
  selector: "app-election-details",
  templateUrl: "./election-details.component.html",
  styleUrls: ["./election-details.component.scss"],
})
export class ElectionDetailsComponent {}
